import { ProposalType } from '@shared/graphql'

import type {
  AddBlockchainAddressProposalDetail,
  ProposalDetail,
  UpdateGroupProposalDetail,
  UpdatePolicyProposalDetail,
  UserManagementProposalDetail,
} from '@shared/graphql'

/**
 * Type guard to check if a proposal is a user management proposal.
 */
export const isUserManagementProposalDetail = (
  proposal?: ProposalDetail,
): proposal is UserManagementProposalDetail =>
  proposal?.type === ProposalType.USER_INVITE ||
  proposal?.type === ProposalType.USER_REMOVE

/**
 * Type guard to check if a proposal is an update management policy proposal.
 */
export const isUpdateManagementPolicyProposalDetail = (
  proposal?: ProposalDetail,
): proposal is UpdatePolicyProposalDetail =>
  proposal?.type === ProposalType.USER_INVITE_POLICY ||
  proposal?.type === ProposalType.USER_REMOVE_POLICY ||
  proposal?.type === ProposalType.BLOCKCHAIN_ADDRESS_ADDITION_POLICY

/**
 * Type guard to check if a proposal is a update group proposal.
 */
export const isUpdateGroupProposalDetail = (
  proposal?: ProposalDetail,
): proposal is UpdateGroupProposalDetail =>
  proposal?.type === ProposalType.UPDATE_GROUP

/**
 * Type guard to check if a proposal is an add blockchain address proposal.
 */
export const isAddBlockchainAddressProposalDetail = (
  proposal?: ProposalDetail,
): proposal is AddBlockchainAddressProposalDetail =>
  proposal?.type === ProposalType.BLOCKCHAIN_ADDRESS_ADDITION
